import { FileUploadDialog } from '../fileupload/FileUploadDialog';
import * as React from 'react';

interface ImportStepFileSelectProps extends React.ClassAttributes<any> {
    data: any;
    onDataChange: (data: any) => void;
    cleanDataOnLoad: boolean;
    onDone: () => void;
}

export class ImportStepFileSelect extends React.Component<ImportStepFileSelectProps, {}> {

    constructor(props: any) {
        super(props);
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    render() {
        return (
            <div>
                <FileUploadDialog
                    onDataLoaded = {this.onDataLoaded}
                />
            </div>
        );
    }

    private onDataLoaded(dataLoaded: string) {
        const data = this.props.data;
        data.raw = dataLoaded;
        data.workbook = undefined; // Das MUSS
        if (this.props.cleanDataOnLoad) {
            data.sheetName = undefined;
            data.sheetNames = undefined;
            data.sheetDataAll = undefined;
            data.selectedFields = undefined;
            data.selectedValues = undefined;
            data.selectedRows = undefined;
            data.headerRow = undefined;
            data.structureKey = undefined;
            data.checkedKeys = undefined;
            data.ignoreRows = undefined;
        }
        // console.log(data);
        // alert('check');
        this.props.onDataChange(data);
        this.props.onDone();
    }
}
